// extracted by mini-css-extract-plugin
export default {"root":"JqqCZr7K","button":"WFfpuJBO","spinner":"Ey6IGxkf","shown":"UDIRXOO8"};